var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoHusa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.743774,
    y: 0.725342,
    width: 34.1609,
    height: 31.03,
    rx: 2.5,
    fill: "#D01422",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9753 8.81887L17.8243 15.4072L24.6974 8.81887L31.498 15.4072V18.76L24.6974 12.1482L17.8243 18.76L12.2822 13.4377V15.5713L17.8243 20.8936L24.6974 14.3052L31.498 20.8936V28.3494H17.8243V24.2229L12.3064 18.9241V28.3494H9.66846V18.9241L4.15058 24.2463V20.917L9.66846 15.5948V13.4846L4.15058 18.8069V15.4072L10.9753 8.81887Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1538 26.0057V22.0772L24.9054 18.1935L20.5589 22.1221V26.0057H29.1538Z",
    fill: "#D01422"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHusa);
export default __webpack_public_path__ + "static/media/logo-husa.eeb2f604.svg";
export { ForwardRef as ReactComponent };